module.exports = __webpack_public_path__ + "img/linkedin-celebrate.77a7c04e.png";